<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Service Questions Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`Service Questions${
        laboratory.code ? `: ${laboratory.code}` : ''
      }`"
      class="mb-3"
    >
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <service-question-server-table />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import ServiceQuestionServerTable from "@/components/lab/servicequestion/ServiceQuestionServerTable";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { getModel } from "@/shared/fetch-utils";

export default {
  name: "ServiceQuestionIndex",
  components: {
    BasicHeading,
    ServiceQuestionServerTable,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$route.params.laboratory_id || null,
      laboratory: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/laboratory",
            title: "Laboratory list",
          },
          {
            icon: "fa-eye",
            linkto: `/laboratory/${this.laboratory_id}`,
            title: "To laboratory",
            variant: "info",
          },
        ],
      };
    },
  },
  async created() {
    this.loading = true;

    this.laboratory = await getModel({
      model_type: "laboratory",
      id: this.laboratory_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
};
</script>
